<!-- 音频播放区 -->
<template>
  <div class="audio-play-area" @click.stop="">
    <div class="audio-header">
      <span class="span-current-time">{{currentTime}}</span>
        &nbsp;/&nbsp;
      <span class="span-total-time">{{totalTime}}</span>
      <span :class="['span-icon', 'icon-play-default']" @click.stop="play()" title="播放"></span>
      <span :class="['span-icon', 'icon-pause-default']" @click.stop="pause()" title="暂停"></span>
      <span :class="['span-icon', 'icon-stop-default']" @click.stop="stop()" title="停止"></span>
      <div class="span-icon icon-outline">
        <div class="icon-volume" title="音量"></div>
        <div class="block">
          <el-slider
            v-model="volume"
            @input="volumeInput">
          </el-slider>
        </div>
      </div>
      
    </div>

    <!-- 音频时间 -->
    <div id="popup-timeline" ref="popupTimeline"></div>
    <!-- 音频波纹 -->
    <div id="popup-waveform" ref="popupWaveform"></div>

  </div>
</template>

<script>
import PopupWaveSurfer from 'wavesurfer.js'// wavesurfer 音频波纹
import PopupTimeline from 'wavesurfer.js/dist/plugin/wavesurfer.timeline'// Timeline音频时间显示插件
// import Region from 'wavesurfer.js/dist/plugin/wavesurfer.regions'// regions音频选中区插件
import Cursor from 'wavesurfer.js/dist/plugin/wavesurfer.cursor' // cursor音频鼠标时间插件

export default {
  name: 'AudioPlayArea',
  components: { },
  props: {
    // 当前音频路径
    currentAudioUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // photoBaseUrl: window.gtaAiConfig.photoDomain, // 资源平台上传基地址
      wavesurfer: null,
      percent: null,
      speed: 1,
      tableData: [],
      currentTime: '00:00:00.000', // 当前播放时间
      totalTime: '00:00:00.000', // 音频总时长
      // 区域时间
      regionalTime: {
        startTime: '00:00:01.000',
        endTime: '00:00:05.000',
      },
      selectLabel: {}, // 选中标签
      volume: 50, // 默认音量
      volumeState: true, // 音量开关状态 true:有音量
      popupActive: '',
    }
  },
  computed: {},
  watch: {
    // 监测音频路径
    currentAudioUrl: {
      handler(val) { //特别注意，不能用箭头函数，箭头函数，this指向全局
        setTimeout(() => {
          this.regionalTime = {
            startTime: '00:00:01.000',
            endTime: '00:00:05.000',
          }
          this.currentTime = '00:00:00.000' // 当前播放时间
          this.totalTime = '00:00:00.000' // 音频总时长
          
          if (val) {
            this.load() // 执行绑定事件-加载音频
          } else {
            this.wavesurfer.destroy() // 销毁waveform，移除事件，元素和关联节点
            this.init() // 加载频音实例
          }
        }, 10);
      },
      immediate: true,  //刷新加载 立马触发一次handler
      deep: true  // 可以深度检测到 obj 对象的属性值的变化
    }
  },
  created() {},
  mounted() {
    this.init() // 加载频音实例
  },
  methods: {
    // 加载频音实例
    init() {
      this.wavesurfer = PopupWaveSurfer.create({
        // container: this.$refs.waveform,//绑定容器，第一种方法
        // container: document.querySelector('#waveform'),//第二种方法
	      container: '#popup-waveform',//第三种方法
        audioRate: this.speed, // 播放音频的速度。数字越低，速度越慢。
        forceDecode: true, // 在缩放时使用web audio强制解码音频，以获得更详细的波形。
        backgroundColor: '#2B3245', // 更改波形容器的背景颜色。
        waveColor: '#0084ff', // 波纹颜色
        progressColor: '#7bbaf9', // 播放波纹颜色
        cursorColor: '#7bbaf9', // 播放进度线颜色
        // backend: 'MediaElement', // WebAudio、MediaElement或MediaElementWebAudio。MediaElement是不受支持浏览器的后备方案。
        barWidth: 3, // 控制波纹宽度
        height: 120, // 波形的高度。以像素为单位测量。
        plugins: [
          PopupTimeline.create({
            container: '#popup-timeline',//绑定容器
            labelPadding: 2
          }),
          // Region.create(),
          Cursor.create({
		      	showTime: true,
		      	opacity: 1,
		      	customShowTimeStyle: {
		      		'background-color': '#000',
		      		color: '#fff',
		      		padding: '2px',
		      		'font-size': '10px'
		      	}
		      })
        ],
      })

      // this.createRegion() // 创建音频选中区域
      this.load() // 执行绑定事件-加载音频
    },
    // 创建音频选中区域
    // createRegion(start, end) {
    //   this.currentRegion = this.wavesurfer.addRegion({
    //     // id: id, // region的id
    //     start: start ? start : 1, // region的开始位置，单位秒
    //     end: end ? end : 5, // region的结束位置，单位秒
    //     loop: false, // 播放完毕后是否循环播放
    //     // drag: false, // 是否支持拖拽
    //     // resize: false, // 是否支持改变region的大小
    //     color: "rgba(254, 255, 255, 0.4)", // 	region的颜色
    //   });
    // },
    load() {
      let _this = this
      if (this.currentAudioUrl) {
        this.wavesurfer.load(this.currentAudioUrl) // 加载音频
      }

      // 加载时候
      this.wavesurfer.on('loading', (percents) => {
        // 当前加载的进度
        // console.log('当前加载的进度')
        this.percent = percents;
      })
      // 加载成功
      this.wavesurfer.on('ready', function() {
        // console.log('// 加载成功');
        _this.totalTime = _this.changeTime(_this.wavesurfer.getDuration()); // 获取音频总时长
      })
      // 播放中
      this.wavesurfer.on('audioprocess', function(e) {
      	_this.currentTime = _this.changeTime(_this.wavesurfer.getCurrentTime()) // 获取当前播放时间
      })
      // 结束播放
      this.wavesurfer.on("finish", () => {
        // _this.wavesurfer.pause();
      });

      // 区域点击
      this.wavesurfer.on('region-click', (region, mouseEvent)=> {
        // console.log('区域点击',region,mouseEvent);
        const { start, end } = region;
        _this.regionalTime = {
          startTime: _this.changeTime(start),
          endTime: _this.changeTime(end),
        };
      	// region.play() // 播放当前区域，另一种播放方式： this.wavesurfer.play(start, end)
      })
      // 区域创建
      this.wavesurfer.on('region-created', (region)=> {
        // console.log('区域创建',region);
      })
      // 区域更新
      this.wavesurfer.on('region-update', (region) => {
        // console.log('区域更新',region);
      })
      // 区域更新结束
      this.wavesurfer.on('region-update-end', (region) => {
        // console.log('区域更新结束',region);
        const { start, end } = region;
        _this.regionalTime = {
          startTime: _this.changeTime(start),
          endTime: _this.changeTime(end),
        };
      	/** 播放区域的两种方式 */
      	// this.wavesurfer.play(this.currentRegion.start, this.currentRegion.end)//①
      	// region.play();// ②
          
      	/** 新增区域列表 */
        //wavesurfer.regions.list:获取音频中的区域列表
      	_this.regionList = Object.values(_this.wavesurfer.regions.list);
      })
    },

    // 设置音量
    volumeInput(val) {
      this.wavesurfer.setVolume(val/100) // 设置音量0-1，0：静音
    },

    // 时间格式化 seconds/单位秒
    changeTime(seconds) {
    	seconds = Number(seconds);
      var hour = Math.floor(seconds / 60 / 60);
      var minutes = Math.floor(seconds / 60) % 60
        seconds = seconds % 60;
    	var secondsStr = Math.round(seconds).toString()
        secondsStr = seconds.toFixed(3);

      let hh = hour > 0 ? (hour < 10 ? '0' + hour : hour) : '00';
      let mm = minutes > 0 ? (minutes < 10 ? '0' + minutes : minutes) : '00';
      let ss = seconds < 10 ? '0' + secondsStr : secondsStr;
      
      return `${hh}:${mm}:${ss}`
    },

    // 重置选中音频片段时间
    onResetTime() {
      this.regionalTime = {
        startTime: '00:00:01.000',
        endTime: '00:00:05.000',
      }
      this.wavesurfer.pause() // 暂停音频
      // this.currentRegion.remove() // 删除原有区域
      // this.createRegion() // 创建音频选中区域
    },

    // 播放音频
    play(){
      this.wavesurfer.play()
    },
    // 暂停音频
    pause(){
      this.wavesurfer.pause()
    },
    // 停止音频回起点
    stop(){
      this.wavesurfer.stop()
      this.currentTime = '00:00:00.000'
    },
  },
  beforeMount() {},
  updated() {},
  beforeDestroy() {
    this.wavesurfer.pause() // 暂停音频
  },
  destroyed() {},
}
</script>
<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.audio-play-area {
  width: 100%;
  height: 100%;
  border: 1px solid #dde5f7;
  padding: 20px;

  .audio-header {
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 12px;
    .span-current-time,
    .span-total-time {
      color: #333333;
      width: 92px;
      height: 24px;
      background: #F6F9FF;
      // border: 1px solid #CCD6F6;
      border-radius: 3px;
      text-align: center;
    }
    .span-total-time {
      margin-right: 22px;
    }
    .span-icon {
      // width: 17px;
      // height: 18px;
      margin-right: 10px;
      display: flex;
      cursor: pointer;
    }
    .icon-play-default {
      width: 15px;
      height: 18px;
      background: url('../../../public/images/icon-play-default.png') no-repeat;
      background-size: 100% 100%;
      &:hover {
        background: url('../../../public/images/icon-play-select.png') no-repeat;
        background-size: 100% 100%;
      }
    }
    .icon-pause-default {
      width: 17px;
      height: 16px;
      background: url('../../../public/images/icon-pause-default.png') no-repeat;
      background-size: 100% 100%;
      &:hover {
        background: url('../../../public/images/icon-pause-select.png') no-repeat;
        background-size: 100% 100%;
      }
    }
    .icon-stop-default {
      width: 18px;
      height: 18px;
      background: url('../../../public/images/icon-stop-default.png') no-repeat;
      background-size: 100% 100%;
      &:hover {
        background: url('../../../public/images/icon-stop-select.png') no-repeat;
        background-size: 100% 100%;
      }
    }
    .icon-play-select {
      background: url('../../../public/images/icon-play-select.png') no-repeat;
      background-size: 100% 100%;
    }
    .icon-pause-select {
      background: url('../../../public/images/icon-pause-select.png') no-repeat;
      background-size: 100% 100%;
    }
    .icon-stop-select {
      background: url('../../../public/images/icon-stop-select.png') no-repeat;
      background-size: 100% 100%;
    }

    .icon-outline {
      width: 17px;
      height: 17px;
      position: relative;
      .icon-volume {
        width: 100%;
        height: 100%;
        background: url('../../../public/images/icon-volume-default.png') no-repeat;
        background-size: 100% 100%;
      }
      &:hover {
        .block {
          display: inline-block;
        }
        .icon-volume {
          background: url('../../../public/images/icon-volume-select.png') no-repeat;
          background-size: 100% 100%;
        }
      }
      .block {
        width: 100px;
        display: none;
        position: absolute;
        top: -10px;
        right: -100px;
        padding-left: 10px;
        z-index: 9;
        &:hover {
          display: inline-block;
        }
        /deep/.el-slider__button {
          width: 8px;
          height: 8px;
        }
      }
    }

    .text-annotation-examples {
      position: absolute;
      top: 0;
      right: 0;
      span {
        float: right;
        color: #4c88ff;
        cursor: pointer;
      }
    }
  }

  #popup-timeline {
    // height: 100px;
    background: rgba(206, 221, 243, 0.26);
    // border-top: 1px solid #000;
    // border-right: 1px solid #000;
    border: 1px solid #DDE5F7;
  }
  #popup-waveform {
    // background-color: #2B3245;
    position: relative;
  }

  /deep/.wavesurfer-region {
    z-index: 3 !important;
    // background: rgba($color: #000000, $alpha: 0.3) !important;
  }
}
</style>
